import { ModelValidator } from '../ModelValidator';
import { CodelistModel } from '../../../../view-model/type/codelist-model';
import { Severity, ValidationNotification } from '../../../../types/app-types';

/**
 * adds info notification for cpv classes according to clean vehicles directive
 */
export class CPVValidator extends ModelValidator<CodelistModel> {
  static readonly CPV_FIELD_INFO =
    'Bei der Auswahl dieses Hauptklassifizierungscodes sind weitere Angaben zur Richtlinie zur Förderung sauberer Fahrzeuge (CVD) notwendig. Diese sind im entsprechenden Los unter dem Abschnitt "Bedingungen für die Einreichung eines Angebots > Informationen zur Richtlinie über saubere Fahrzeuge" im BT-717-Lot ff. zu tätigen.';

  //List of all cpv classes which are subject to the cvd
  private readonly CPV_CLASS = [
    '3411',
    '3412',
    '3413',
    '3414',
    '6012',
    '6013',
    '6014',
    '6016',
    '6017',
    '6018',
    '6412',
    '9051',
  ];

  async validate(model: CodelistModel): Promise<ValidationNotification[]> {
    if (this.CPV_CLASS.some(code => model.value?.startsWith(code))) {
      return this.ofSingle(CPVValidator.CPV_FIELD_INFO, Severity.INFO);
    }
    return this.empty();
  }

  shouldAttach(model: CodelistModel): boolean {
    return (
      model.noticeNode?.id === 'BT-262-Procedure' ||
      model.noticeNode?.id === 'BT-262-Lot' ||
      model.noticeNode?.id === 'BT-262-Part'
    );
  }
}
